import React from "react";
import './PortraitSelector.css';

function PortraitSelector({ selectedImage, setSelectedImage, setShowPortraitSelector }) {
    const images = [657, 659, 660, 661, 662, 663, 664, 665, 666, 667, 668, 669, 670, 671, 672, 673, 674, 675, 676, 677];

    return (
        <div className="portrait-selector-overlay" onClick={() => setShowPortraitSelector(false)}>
            <div className="portrait-selector-modal" onClick={(e) => e.stopPropagation()}>
                <div className="portrait-header">
                    <h2>Select a Portrait</h2>
                </div>
                <div className="portrait-content">
                    <div className="portrait-grid">
                        {images.map((imgId) => (
                            <div
                                key={imgId}
                                className={`portrait-item ${selectedImage === imgId ? 'selected' : ''}`}
                                onClick={() => setSelectedImage(imgId)}
                                tabIndex="0"
                                onKeyPress={(e) => e.key === 'Enter' && setSelectedImage(imgId)}
                            >
                                <img
                                    className="pimg"
                                    src={require(`../../Assets/gfx/${imgId}.webp`)}
                                    alt={`Portrait ${imgId}`}
                                />
                                {selectedImage === imgId && (
                                    <div className="selection-overlay">
                                        <span className="material-symbols-outlined">check</span>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
                <div className="portrait-actions">
                    <button className="back" onClick={() => setShowPortraitSelector(false)}>
                        <span className="material-symbols-outlined">cancel</span>
                        Cancel
                    </button>
                    <button
                        className="sign"
                        onClick={() => {
                            if (selectedImage) {
                                setShowPortraitSelector(false);
                            }
                        }}
                        disabled={!selectedImage}
                    >
                        <span className="material-symbols-outlined">check_circle</span>
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PortraitSelector;